import { render, staticRenderFns } from "./verticalCatalog.vue?vue&type=template&id=9fc6f544&scoped=true"
import script from "./verticalCatalog.vue?vue&type=script&lang=js"
export * from "./verticalCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc6f544",
  null
  
)

export default component.exports